module.exports = __webpack_public_path__ + "assets/data.74c79e45.svg";